import cloneDeep from 'lodash/cloneDeep'

const getters = {
  tableData: state => {
    return state.tableData
  },
  chartData: state => {
    return state.chartData
  },
  middleLang: state => {
    return state.middleLang
  },
  today: state => {
    return state.today
  },
  BPList: state => {
    return state.BPList
  },
  selectedIOId: state => {
    return state.selectedIOId
  },
  IOProgressData: state => {
    const tableData = cloneDeep(state.tableData)
    const selectedIOId = cloneDeep(state.selectedIOId)
    return tableData.find(o => o.insertionOrderId === selectedIOId)
  },
}

export default getters
